
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class BambooForestEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, height } = pc;
        const spacing = (80 + layerIndex * 40) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        
        for (let x = x1; x <= x2; x += spacing) {
            const w = (10 + layerIndex * 5) * scale;
            const h = height * 2;
            
            const draw = () => {
                ctx.lineWidth = w;
                ctx.beginPath();
                ctx.moveTo(x, -height);
                ctx.lineTo(x, height);
                ctx.stroke();
                
                // Segments
                ctx.lineWidth = 2 * scale;
                ctx.strokeStyle = 'rgba(0,0,0,0.2)';
                for (let sy = -height; sy < height; sy += 100) {
                    ctx.beginPath();
                    ctx.moveTo(x - w/2, sy);
                    ctx.lineTo(x + w/2, sy);
                    ctx.stroke();
                }
                ctx.strokeStyle = pc.color;
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
